var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"left cursor-pointer",on:{"click":_vm.onBack}},[_c('i',{staticClass:"el-icon-back"})]),_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item){return _c('el-breadcrumb-item',{key:item.path},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }